import styled from '@emotion/styled';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { LegacyVideoPlayer } from 'src/modules/programs/components/LegacyVideoPlayer';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';
import { getVideoUrlById } from 'src/modules/videos/selectors/videosSelectors';
import myraImg from 'src/public/img/care-advocate-myra.png';
import { color, font } from 'src/shared/styles/variables';

export const AuthorInfo = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: '1.5rem',
});

export const AuthorImage = styled('img')({
    width: '7rem',
    borderRadius: 5,
    marginRight: '1.5rem',
});

export const AuthorName = styled('h4')(
    {
        color: color.chathamsBlue,
        marginBottom: 0,
    },
    font.heavy(font.size.medium),
);

export const Company = styled('h5')(
    {
        color: color.mamba,
        marginTop: '0.5rem',
    },
    font.medium(font.size.medium),
);

interface StateProps {
    videoUrl: string | null;
    overviewContent?: string;
}

interface MatchProps {
    programId: ProgramEnum;
    programTitle: string;
}

type Props = StateProps & MatchProps & WithTranslation;

const ProgramOverviewStepContainer: React.SFC<Props> = ({ programTitle, videoUrl, t }) => {
    const elements: string[] = t('week-1.program-overview.bulletList.elements', {
        returnObjects: true,
    });

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepHeading>{t('week-1.program-overview.title')}</S.StepHeading>
                    {videoUrl && (
                        <LegacyVideoPlayer
                            title={`${programTitle} Program Overview`}
                            src={videoUrl}
                        />
                    )}
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow>
                <S.ContentColumn md={10}>
                    <AuthorInfo>
                        <AuthorImage alt="Dr. Myra Altman" src={myraImg} />
                        <div>
                            <AuthorName>{t('week-1.program-overview.author')}</AuthorName>
                            <Company>Modern Health</Company>
                        </div>
                    </AuthorInfo>
                </S.ContentColumn>
                <S.ContentColumn md={14}>
                    <S.StepDescription small>
                        {t('week-1.program-overview.description.1')}
                    </S.StepDescription>
                    <S.StepDescription small>
                        <S.Strong>{t('week-1.program-overview.bulletList.heading')}</S.Strong>
                    </S.StepDescription>
                    <S.BulletList>
                        {elements.map((element: string) => (
                            <S.BulletListElement key={element}>{element}</S.BulletListElement>
                        ))}
                    </S.BulletList>
                    <S.StepDescription small>
                        {t('week-1.program-overview.description.2')}
                    </S.StepDescription>
                </S.ContentColumn>
            </S.ContentRow>
        </>
    );
};

const mapStateToProps = (state: AppState): StateProps => ({
    videoUrl: getVideoUrlById(state, 'cbt-week-1'),
});

export const ProgramOverviewStep = withTranslation('cbt')(
    connect(mapStateToProps)(ProgramOverviewStepContainer),
);
